import React from 'react'

/**
 * 权限配置
 */
export const AuthorizedConfiguration: React.FC = React.memo((props) => {
  const { children } = props
  return <>{children}</>
})

AuthorizedConfiguration.displayName = 'AuthorizedConfiguration'
